export default "__VITE_ASSET__GTHJ7sbq__"